var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('draggable-options',{attrs:{"id":"draggable-options","field":_vm.field,"supported-languages":_vm.supportedLanguages,"read-only":_vm.readOnly,"is-wrapped":true},on:{"errors":_vm.handleErrors,"updated":_vm.refreshPreview}})}
var staticRenderFns = []

export { render, staticRenderFns }